import React, { useEffect, useState } from "react";
import { Button } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import CartItem from "../Cart/CartItem";
import { useDispatch, useSelector } from "react-redux";
import { getOrderById } from "../../../Redux/Customers/Order/Action";
import AddressCard from "../adreess/AdreessCard";
import { createPayment, updatePayment } from "../../../Redux/Customers/Payment/Action";
import { toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const OrderSummary = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const orderId = searchParams.get("order_id");
  const dispatch = useDispatch();
  const jwt = localStorage.getItem("jwt");
  const { order } = useSelector((state) => state);

  const [showPaymentOptions, setShowPaymentOptions] = useState(false);

  useEffect(() => {
    dispatch(getOrderById(orderId));
  }, [orderId, dispatch]);

  const handlePaymentClick = () => {
    setShowPaymentOptions(true);
  };

  const handleOnlinePayment = () => {
    const data = { orderId: order.order?._id, jwt };
    dispatch(createPayment(data)); 

    toast.success("Payment Successful! Your order is being processed.", {
      position: toast.POSITION.TOP_CENTER,
      autoClose:2000,  // Close the popup after 3 seconds
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      className: "custom-toast-success",
    });

    setTimeout(() => {
      navigate(`/order/detail/${orderId}`);
    }, 2000);
  };

  const handleCODPayment = () => {
    const data = { orderId: order.order?._id, paymentMethod: "COD", jwt };
    dispatch(updatePayment(data)); 

    toast.info("Cash on Delivery selected. Your order is being processed.", {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 2000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      className: "custom-toast-info",
    });

    setTimeout(() => {
      navigate(`/order/detail/${orderId}`);
    }, 3000);
  };

  return (
    <div className="space-y-5">
      <div className="p-5 shadow-lg rounded-md border">
        <AddressCard address={order.order?.shippingAddress} />
      </div>
      <div className="lg:grid grid-cols-3 relative justify-between">
        <div className="lg:col-span-2">
          <div className="space-y-3">
            {order.order?.orderItems.map((item) => (
              <CartItem key={item._id} item={item} showButton={false} />
            ))}
          </div>
        </div>
        <div className="sticky top-0 h-[100vh] mt-5 lg:mt-0 ml-5">
          <div className="border p-5 bg-white shadow-lg rounded-md">
            <p className="font-bold opacity-60 pb-4">PRICE DETAILS</p>
            <hr />

            <div className="space-y-3 font-semibold">
              <div className="flex justify-between pt-3 text-black">
                <span>Price ({order.order?.totalItem} item)</span>
                <span>₹{order.order?.totalPrice}</span>
              </div>
              <div className="flex justify-between">
                <span>Discount</span>
                <span className="text-green-700">-₹{order.order?.discounte}</span>
              </div>
              <div className="flex justify-between">
                <span>Delivery Charges</span>
                <span className="text-green-700">Free</span>
              </div>
              <hr />
              <div className="flex justify-between font-bold text-lg">
                <span>Total Amount</span>
                <span className="text-green-700">₹{order.order?.totalDiscountedPrice}</span>
              </div>
            </div>

            {!showPaymentOptions && (
              <Button
                onClick={handlePaymentClick}
                variant="contained"
                type="submit"
                sx={{ padding: ".8rem 2rem", marginTop: "2rem", width: "100%" }}
              >
                Payment
              </Button>
            )}

            {showPaymentOptions && (
              <div className="space-y-2">
                <Button
                  onClick={handleOnlinePayment}
                  variant="contained"
                  sx={{ padding: ".8rem 2rem", marginTop: "1rem", width: "100%" }}
                >
                  Pay Online
                </Button>

                <Button
                  onClick={handleCODPayment}
                  variant="contained"
                  color="secondary"
                  sx={{ padding: ".8rem 2rem", width: "100%" }}
                >
                  Cash on Delivery
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderSummary;
